import React from "react";

const Modal = ({ isOpen, toggleModal }) => {
    return (
        <div className={`modal ${isOpen ? 'show' : 'hide'}`} id="options-modal">
            <div className="modal-content premium-modal-content">
                <h2>Exclusivo para cliente premium</h2>
                <p>Desbloqueie todos os recursos da nossa plataforma e aproveite ao máximo sua experiência.Logo você poderá assinar e descubrir as vantagens que só quem é premium pode ter!</p>
                <button className="btn" id="close-modal" onClick={toggleModal}>Fechar</button>
            </div>
        </div>
    );
}

export default Modal;